module.exports = __webpack_public_path__ + "static/media/biaacc_ppg1.622e5fed.jpg";